import interact from 'interactjs'

let drag = interact('.drag').draggable({
  listeners: {
    start(event) {
      event.target.classList.add('active')
      event.target.dataset.dragged = 'false'
    },
    end(event) {
      event.target.classList.remove('active')
    },
    // call this function on every dragmove event
    move(event) {
      var target = event.target
      target.dataset.dragged = 'true'

      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      target.style.transform = `translate(${x}px,${y}px)`

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    }
  }
})

let drop = interact('.dropzone').dropzone({
  accept: '.drag', 
  overlap: 0.75,   

  // listen for drop related events:
  ondropactivate: function (event) {
    // feedback for available drop zones
    event.target.classList.add('dropzone--ready')
  },
  ondragenter: function (event) {
    // feedback the possibility of a drop
    event.target.classList.add('dropzone--over')
    event.relatedTarget.classList.add('can-drop')

  },
  ondragleave: function (event) {
    // remove the drop feedback style
    event.target.classList.remove('dropzone--over')
    event.relatedTarget.classList.remove('can-drop')
    event.relatedTarget.classList.remove('dropped')
    event.relatedTarget.dispatchEvent(new Event('unheld'))
  },
  ondrop: function (event) {
    event.relatedTarget.dispatchEvent(new Event('held'))
    event.relatedTarget.classList.add('dropped')
    // event.relatedTarget.setAttribute('data-held', true)

  },
  ondropdeactivate: function (event) {
    // remove active dropzone feedback
    event.target.classList.remove('dropzone--ready')
    event.target.classList.remove('dropzone--over')
  }
})

export {drag,drop}
